import _ from '@/utils/lodash-optimized'
import React from 'react'

import { onlyNumbers } from '../../../../lib/Form'
import {
  bindTargetMixin,
  CancelButton,
  MaskedTextInput,
  SaveButton,
  TextInput,
  YesNoRadioOptions,
  QuestionRadioButtonInput
} from '../../../shared/FormBuilder'

const style = {
  marg: {
    marginTop: '1rem'
  },
  saveButton: {
    marginLeft: '1rem'
  },
  textField1: {
    marginBottom: '1rem',
    width: '100%'
  }
}

class VitalsForm extends bindTargetMixin(React.Component) {
  componentDidMount () {
    let weightValue = false
    let heightValue = false
    if (this.state.value) {
      weightValue = this.state.value.weight
      heightValue = this.state.value.height
    }
    if (weightValue && heightValue) {
      this.calculateBmi(this.state.value.weight, this.state.value.height)
    }
  }

  componentDidUpdate (prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      const weightValue = this.state.value.weight
      const heightValue = this.state.value.height
      if (weightValue && heightValue) {
        this.calculateBmi(this.state.value.weight, this.state.value.height)
      }
      if (!weightValue || !heightValue) {
        this.noBmi()
      }
    }
  }

  noBmi = () => {
    const newState = this.state.value
    newState.bmi = undefined
    this.setState({
      value: newState
    })
  }

  calculateBmi = (weight, height) => {
    if (weight && height) {
      const w = onlyNumbers(weight)
      const h = onlyNumbers(height)
      const h2 = h * h
      const bmi = (w / h2) * 703
      const newState = this.state.value
      newState.bmi = bmi.toFixed(2)
      this.setState({
        value: newState
      })
    }
  }

  getValues = () => ({ ...this.state.value })

  handleSubmit = () => {
    const { onSubmit } = this.props
    onSubmit(this.getValues())
  }

  render () {
    const disabled = _.isEqual(this.props.initialValues, this.state.value)
    return (
      <form>
        <div className='row'>
          <div className='col-xs-6 col-sm-3'>
            <MaskedTextInput
              mask='11.1'
              label='Temperature °F'
              conditional='Temp'
              name='temperature'
            />
          </div>
          <div className='col-xs-6 col-sm-3'>
            <MaskedTextInput
              label='Pulse'
              name='pulse'
              mask='111 BPM'
            />
          </div>
          <div className='col-xs-6  col-sm-3'>
            <MaskedTextInput
              label='Blood (systolic)'
              name='systolic'
              mask='111'
            />
          </div>
          <div className='col-xs-6  col-sm-3'>
            <MaskedTextInput
              label='Blood (diastolic)'
              name='diastolic'
              mask='111'
            />
          </div>
          <div className='col-xs-6 col-sm-3'>
            <MaskedTextInput
              label='Respiratory Rate'
              name='respiratoryRate'
              mask='11 BPM'
            />
          </div>
          <div className='col-xs-6 col-sm-3'>
            <MaskedTextInput
              label='Weight (lbs)'
              name='weight'
              mask='111 lbs'
            />
          </div>
          <div className='col-xs-6 col-sm-3'>
            <MaskedTextInput
              label='Height (inches)'
              name='height'
              mask='11 inches'
            />
          </div>
          <div className='col-xs-6 col-sm-3'>
            <TextInput
              label='BMI kg/m²'
              disabled
              name='bmi'
            />
          </div>
          <div className='col-xs-6 col-sm-3'>
            <MaskedTextInput
              label='O2 Saturation %'
              name='pulseOxygen'
              mask='111'
            />
          </div>
        </div>
        <div>
          <QuestionRadioButtonInput
            question='Were vitals reported by patient?'
            name='reportedByPatient'
            radioButtons={YesNoRadioOptions}
          />
          <QuestionRadioButtonInput
            question='Were vitals obtained via medical record?'
            name='obtainedViaMedRec'
            radioButtons={YesNoRadioOptions}
          />
        </div>
        <div
          className='row start-xs'
          style={style.marg}
        >
          <div className='col-xs-12 end-xs'>
            <CancelButton
              formKey={this.props.formKey}
              onClick={this.props.cancel}
            />

            <SaveButton
              formKey={this.props.formKey}
              onClick={this.handleSubmit}
              disabled={disabled}
            />
          </div>
        </div>
      </form>
    )
  }
}

export default VitalsForm
